import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CATEGORIES = [
  { name: 'GPU & AI Compute', slug: 'gpu-ai-compute' }, { name: 'CPUs', slug: 'cpus' }, { name: 'Memory', slug: 'memory' },
  { name: 'Enterprise Storage', slug: 'enterprise-storage' }, { name: 'Servers', slug: 'servers' }, { name: 'Workstations', slug: 'workstations' },
  { name: 'Networking', slug: 'networking' }, { name: 'Consumer Technology', slug: 'consumer-technology' },
];

const slug = (s) => s.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

const pillClass = (i) => {
  if (i === 0) return 'bg-[#0096D6] border-[#0096D6] text-white hover:bg-[#007bb0]';
  if (i === CATEGORIES.length - 1) return 'bg-slate-50 border-slate-200 text-slate-500 hover:text-slate-700 hover:border-slate-300';
  return 'bg-white border-slate-200 text-slate-700 hover:border-[#0096D6]/50 hover:text-[#0096D6]';
};

export const HardwareCategoryStrip = () => (
  <motion.div
    id="hardware-categories"
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.9, duration: 0.6 }}
    className="relative z-20 w-full border-t border-slate-200/70 bg-white/80 backdrop-blur-md scroll-mt-28"
    data-testid="hardware-category-strip"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 md:py-7">
      <div className="flex flex-wrap items-center gap-2.5" data-testid="hardware-category-pills">
        {CATEGORIES.map((cat, i) => (
          <Link
            key={cat.slug}
            to={`/products?category=${cat.slug}`}
            className={`px-4 py-2 rounded-full border font-manrope text-sm font-medium transition-colors duration-300 ${pillClass(i)}`}
            data-testid={`category-pill-${slug(cat.name)}`}
          >
            {cat.name}
          </Link>
        ))}
      </div>

      <div className="mt-6 pt-6 border-t border-slate-200/60 grid gap-2 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] lg:gap-10 items-start">
        <p className="font-outfit text-lg md:text-xl font-semibold text-slate-900 leading-snug" data-testid="hardware-statement">
          From fast-moving components to high-value compute infrastructure.
        </p>
        <p className="font-manrope text-sm md:text-base text-slate-600 leading-relaxed" data-testid="hardware-statement-support">
          Real Tech Services supplies technology businesses across international markets with commercially competitive hardware opportunities, from individual components through to high-value computing systems.
        </p>
      </div>
    </div>
  </motion.div>
);
